import templateUrl from "./503.component.html";
import "./error-page.less";

export const ServiceUnavailableComponent = {
    templateUrl
};
